import type StylerModule from "./styler";

export default class CompoundStyler {
    private styler: StylerModule;

    constructor(styler: StylerModule) {
        this.styler = styler;
    }

    /**
     * 
     * @param styler 
     * @param style 
     * @param feature 
     * @param layerViewInfo 
     * 
     * @returns 
     */
    getStyle(styler, style, feature, layerViewInfo) {
        style = this.styler.getStyle(styler.baseStyler, style, feature, layerViewInfo);
        
        // TOR9-8525 - If ConditionalStyler creates a new Style it overwrites EVERY STYLE SETTING, so ignore other stylers...
        const condStyle = this.getConditionalStyle(styler.stylers, style, feature, layerViewInfo);
        if (condStyle) {
            return condStyle;
        }
        
        for (let i = 0; i < styler.stylers.length; i++) {
            style = this.styler.getStyle(styler.stylers[i], style, feature, layerViewInfo);
        }
        
        return style;
    }

    /**
     * 
     * @param stylers 
     * @param baseStyle 
     * @param feature 
     * @param layerViewInfo 
     * 
     * @returns 
     */
    private getConditionalStyle(stylers, baseStyle, feature, layerViewInfo) {
        // TOR9-8525 - If ConditionalStyler creates a new Style it overwrites EVERY STYLE SETTING, so ignore other stylers...
        let condStyle;
        for (let i = 0; i < stylers.length; i++) {
            const styler = stylers[i];
            
            if (styler.$type == 'ConditionalStyler') {
                const newStyle = this.styler.getStyle(styler, baseStyle, feature, layerViewInfo);
                
                if (newStyle != baseStyle) {
                    condStyle = newStyle;
                    break;
                }
            }
        }
        
        // TOR9-8525 / TOR9-8576 - ...Unless it's a SymbolAndPolygonStyle... then we keep the symbol from the conditional style, and get the new polygon style
        if (condStyle && condStyle.$type == 'SymbolAndPolygonStyle') {
            let style = baseStyle;
            for (let i = 0; i < stylers.length; i++) {
                const styler = stylers[i];

                if (styler.$type != 'ConditionalStyler') {
                    style = this.styler.getStyle(styler, style, feature, layerViewInfo);
                }
            }
            
            condStyle.polygonStyle =  style.polygonStyle;
        }
        
        return condStyle;
    }    
    
    /**
     * 
     * @param styler 
     * 
     * @returns 
     */
    getPaddingPx(styler): number[] {
        const paddingPx = this.styler.getPaddingPx(styler.baseStyler);
        
        for (let i = 0; i < styler.stylers.length; i++) {
            const p = this.styler.getPaddingPx(styler.stylers[i]);
            paddingPx[0] = Math.max(paddingPx[0], p[0]);
            paddingPx[1] = Math.max(paddingPx[1], p[1]);
        }
        
        return paddingPx;
    }
    
    /**
     * 
     * @param styler 
     * 
     * @returns 
     */
    hasDirect(styler): boolean {
        let hasDirect = this.styler.hasDirect(styler.baseStyler);
        
        for (let i = 0; !hasDirect && i < styler.stylers.length; i++) {
            hasDirect = this.styler.hasDirect(styler.stylers[i]);
        }
        
        return hasDirect;
    }
    
    /**
     * 
     * @param styler 
     * 
     * @returns 
     */
    hasOverlays(styler): boolean {
        let hasOverlays = this.styler.hasOverlays(styler.baseStyler);
        
        for (let i = 0; !hasOverlays && i < styler.stylers.length; i++) {
            hasOverlays = this.styler.hasOverlays(styler.stylers[i]);
        }
        
        return hasOverlays;
    }
    
    /**
     * 
     * @param styler 
     * 
     * @returns 
     */
    getHideFeaturesCriteria(styler) {
        const criterias = styler.stylers
            .map((s) => this.styler.getHideFeaturesCriteria(s))
            .filter((c) => c != null);
        
        return es.util.criteria.and.apply(es.util.criteria, criterias);
    }
}
